module.exports = __webpack_public_path__ + "img/background-woman-therapist.09af91f2.jpg";